var timer;

// Can be 'single' or 'double'
const clickType = localStorage.getItem('clickType') ?? 'single';

const singleClickTask = (taskId) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
        // alert('Single');

        if (clickType === 'double') return;

        loadOnce(`t/${taskId}`);
        openedTaskId = taskId;
    }, 250);
};
const dblClickTask = (taskId) => {
    clearTimeout(timer);
    // alert('Double');

    if (clickType === 'single') return;

    if (
        openedTaskId !== taskId &&
        document.selection &&
        document.selection.empty
    ) {
        document.selection.empty();
    } else if (openedTaskId !== taskId && window.getSelection) {
        var sel = window.getSelection();
        sel.removeAllRanges();
    }

    openedTaskId = taskId;
    load(`t/${taskId}`);
};

window.singleClickTask = singleClickTask;
window.dblClickTask = dblClickTask;

// window.addEventListener('click', function (evt) {
//     if (evt.detail === 3) {
//         alert('triple click!');
//     }
// });
